var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":""}},[_c('v-card',{staticClass:"flex",attrs:{"flat":"","tile":"","color":"bgBar"}},[_c('v-card-text',{staticClass:"py-2 text-center"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" "),_c('strong',[_vm._v("rukari.com")]),_vm._v(" "+_vm._s(this.version)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }